import { AccountType } from '../shared/types'
import { InputSelectOption } from "@sharedComponents/InputSelect/types";

export enum FormType {
    Campsite = 'campsite',
    SkiResort = 'ski-resort',
    WorkPlace = 'workplace',
}

export type CampsiteFormProps = {
    myPagesRoute: string
    helpText?: any
    cmsContent?: any
    termsAndConditions?: any
    termsAndConditionsButtons?: Array<any>
    onCancel: Function
    onHide: Function
    open: boolean
    formType?: string | undefined
}

export type Step2ValueModel = {
    organizationNumber: string
    changeOwner: string
    changeOwnerDate?: string
    legalName?: string
    registeredForFTax: string
    registeredForVAT: string
    vatNumber?: string
    charity: string
    donateName?: string
    donateOrganisationNumber?: string
    accountType?: AccountType
    bg?: string
    pg?: string
    donateAccountType?: AccountType
    donateBg?: string
    donatePg?: string
    careOf?: string
    streetBox?: string
    zipCode?: string
    city?: string
}

export type Step3ValueModel = {
    campsiteName?: string
    municipality?: InputSelectOption
    visitingAddress: {
        streetAddress?: string
        zipCode?: string
        city?: string
        isAlsoDeliveryAddress?: boolean
    }
    postalAddress: {
        streetAddress?: string
        zipCode?: string
        city?: string
    }
    deliveryAddress: {
        streetAddress1?: string
        streetAddress2?: string
        zipCode?: string
        city?: string
    }
    message?: string
    heard?: InputSelectOption
}